import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Form.module.scss';

type FormControlProps = React.HTMLAttributes<HTMLDivElement>;

const FormControl = forwardRef<HTMLDivElement, FormControlProps>(
    function FormControl({ className, ...props }, ref) {
        return (
            <div
                ref={ref}
                className={cn(styles.FormControl, className)}
                {...props}
            />
        );
    },
);

export { FormControl };
